import { Article } from '@zooplus/checkout-state';

import { ARTICLE_TYPE } from '@utilities/constants';

import BonusPointItem from './cart-item-types/bonus-point-item';
import FreeItem from './cart-item-types/free-item';
import SampleItem from './cart-item-types/sample-item';
import SavingsPlanItem from './cart-item-types/savings-plan-item';
import StandardItem from './cart-item-types/standard-item';
import styles from './cart-item.module.scss';

const CartItem = (article: Article) => {
  const renderCartItem = () => {
    switch (article.type) {
      case ARTICLE_TYPE.SAVINGS_PLAN:
        return <SavingsPlanItem {...article} />;

      case ARTICLE_TYPE.FREE:
        return <FreeItem {...article} />;

      case ARTICLE_TYPE.BONUS:
        return <BonusPointItem {...article} />;

      case ARTICLE_TYPE.FREE_SAMPLE:
        return <SampleItem {...article} />;

      default:
        return <StandardItem {...article} />;
    }
  };

  return (
    <article
      className={styles.productContainer}
      data-testid={`${article.type.toLowerCase()}-article`}>
      {renderCartItem()}
    </article>
  );
};

export default CartItem;
